import { render, staticRenderFns } from "./ServiceReviewForm.vue?vue&type=template&id=6e516d14&scoped=true&"
import script from "./ServiceReviewForm.vue?vue&type=script&lang=js&"
export * from "./ServiceReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceReviewForm.vue?vue&type=style&index=0&id=6e516d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e516d14",
  null
  
)

export default component.exports